import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Required } from "@countdown/theme";
import { useId, useState } from "react";
import { BUTTON_CLASS, FIELD_CLASS } from "./styles.js";
/**
 * "Ungeprüft übernehmen" for a file the security check could not clear: the file stays the
 * one just chosen, the tenant admin names a reason, and the audit row keeps it. The native
 * twin of the backoffice's control of the same name, for the door editor.
 */
export function UnscannedAccept({ busy, onAccept, }) {
    const id = useId();
    const [reason, setReason] = useState("");
    const usable = reason.trim().length >= 3;
    return (_jsxs("div", { className: "mt-4 grid gap-2 rounded-md bg-surface-sunken p-3", children: [_jsx("p", { className: "text-sm", children: "Die Datei konnte nicht gepr\u00FCft werden. Als Mandanten-Admin k\u00F6nnen Sie sie trotzdem \u00FCbernehmen; der Grund steht danach im Protokoll." }), _jsxs("label", { className: "text-sm font-medium", htmlFor: `${id}-reason`, children: ["Grund", _jsx(Required, {})] }), _jsx("input", { id: `${id}-reason`, className: FIELD_CLASS, "aria-required": "true", value: reason, maxLength: 500, disabled: busy, placeholder: "z. B. Datei selbst gepr\u00FCft, Pr\u00FCfung auf dieser Umgebung nicht verf\u00FCgbar", onChange: (event) => {
                    setReason(event.target.value);
                } }), _jsx("button", { type: "button", className: `${BUTTON_CLASS} w-max`, disabled: busy || !usable, onClick: () => {
                    onAccept(reason.trim());
                }, children: "Ungepr\u00FCft \u00FCbernehmen" })] }));
}
//# sourceMappingURL=UnscannedAccept.js.map